export const authKey = 'accessToken';